<div class="picture-preview-wrapper" [class.visible]="show">
  <div class="picture-preview-body-wrapper" *ngIf="show">
    <div class="header-wrapper">
      <button type="button" class="btn btn-primary close-button" (click)="close.emit()"><i i-bs name="x" width="28"
          height="28"></i></button>
    </div>
    <div class="content-wrapper">
      <carousel [isAnimated]="true" [(activeSlide)]="selectedIndex">
        <slide *ngFor="let picture of pictures">
          <img [src]="picture" class="dish-preview-image-big">
        </slide>
      </carousel>
    </div>
  </div>
</div>
